import { IDWSession } from "@idw-types/data/idw-session";

export enum SessionActionTypes {
    SET_SESSION_LOADING = "SET_SESSION_LOADING",
    SET_SESSION = "SET_SESSION",
    INCREMENT_REQUEST_COUNT = "INCREMENT_REQUEST_COUNT"
}

type SetSessionLoadingAction = {
    type: SessionActionTypes.SET_SESSION_LOADING,
    payload: { isLoading: boolean; }
};

export const setSessionLoading = (isLoading: boolean): SetSessionLoadingAction => ({
    type: SessionActionTypes.SET_SESSION_LOADING,
    payload: { isLoading }
});

type SetSessionAction = {
    type: SessionActionTypes.SET_SESSION,
    payload: { session: IDWSession; }
}

export const setSession = (session: IDWSession): SetSessionAction => ({
    type: SessionActionTypes.SET_SESSION,
    payload: { session }
});

type IncrementRequestCountAction = {
    type: SessionActionTypes.INCREMENT_REQUEST_COUNT
}

export const incrementRequestCount = (): IncrementRequestCountAction => ({
    type: SessionActionTypes.INCREMENT_REQUEST_COUNT
});

export type SessionActions =
    SetSessionLoadingAction |
    SetSessionAction |
    IncrementRequestCountAction